/**
 * 代驾端 DidiJSBridge 封装
 * 参考：https://git-hz.xiaojukeji.com/kui/native/tree/master
 * @author linkFly(jianglai@didichuxing.com)
 */

import { ERR_OK } from '../util/index'


function getBridge() {
  return window.WebJsBridge || null
}

export default (name, params, callback) => {
  const bridge = getBridge()
  if (bridge) {
    let res = bridge[name](params)
    callback(res)
  } else {
    throw Error('android WebJsBridge notfound')
  }
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgedaijiadriver/android.js